import { QueryString } from "@/app/shared/filter";

export class SortQueryString extends QueryString {
    public override get isNoValue(): boolean {
        return this._value === '';
    }
    override _fieldModelName: string = "sortBy";
    override _fieldName: string = "sortBy";
    constructor(value: any = "", sort: number = 0) {
        super();
        this._value = value;
    }
}